import React, { Component } from 'react';
// import _ from 'lodash';
import PropTypes from 'prop-types';
import { SORT_DIRECTION } from '../../../util/CrosstabUtils';
import InfoBox, { InfoBoxSpacer } from '../EnhancedGridFeature/InfoBox';
import GridItemName from '../EnhancedGridFeature/GridItemName';
import Label from '../EnhancedGridFeature/Label';
import EditGridItem from '../EnhancedGridFeature/EditGridItem';
import EditExpression from '../EnhancedGridFeature/EditExpression';
import whiteEllipsisIcon from '../../../images/white-menu-icon.svg';
import GlobalDelete from '../EnhancedGridFeature/GlobalDelete';
import { MIN_ROW_HEIGHT } from '../../../constants';

import AutocodeLabelsGenerator, {
  ACStandardLabels,
} from '../../autocode/AutocodeLabelsGenerator';

const { toLabelString } = AutocodeLabelsGenerator(ACStandardLabels, null);

class ColumnHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      header: props.header,
      editEnabled: false,
    };
  }

  onPrivateEyeSort = (key, columnIndex) => {
    let sortOrder = SORT_DIRECTION.DESC;
    if (
      this.props.sortColumnIndex === columnIndex &&
      this.props.sortKey === key
    ) {
      switch (this.props.sortOrder) {
        case SORT_DIRECTION.DESC:
          sortOrder = SORT_DIRECTION.ASC;
          break;
        case SORT_DIRECTION.ASC:
          sortOrder = SORT_DIRECTION.NONE;
          break;
        default:
          sortOrder = SORT_DIRECTION.DESC;
      }
    }
    this.props.onSort(sortOrder, key, columnIndex);
  };

  getClassName = count => {
    switch (count) {
      case 1:
        return { width: '100%' };
      case 2:
        return { width: '50%' };
      case 3:
        return { width: '33.3%' };
      case 4:
        return { width: '25%' };
      case 5:
        return { width: '20%' };
      default:
        return { width: '0%' };
    }
  };

  buildInfoBox = (header, showingFullNames, columnIndex) => {
    const ibp = [];
    if (!showingFullNames || header.isColumnLabelUpdated) {
      ibp.push(
        <GridItemName
          header="Original Name"
          body={this.getHeaderLabel(this.state.header, true)}
          ShowRestoreButton={header.isColumnLabelUpdated}
          restoreGridTitle={this.props.restoreGridTitle}
          index={columnIndex}
          gridType="ColumnsDataGrid"
        />
      );
      ibp.push(
        <InfoBoxSpacer
          Height="1em"
          boxClassName="toolPalette-spacer-row ibox-spacer-hline"
        />
      );
    }

    ibp.push(
      <EditGridItem
        updateGridTitle={this.props.updateGridTitle}
        index={columnIndex}
        gridType="ColumnsDataGrid"
      />
    );
    ibp.push(
      <InfoBoxSpacer
        Height="0.1em"
        boxClassName="toolPalette-spacer-row ibox-spacer-hline"
      />
    );
    ibp.push(
      <EditExpression
        handleEditExpression={this.props.handleCrosstabEdit}
        index={columnIndex}
        gridType="ColumnsDataGrid"
      />
    );
    ibp.push(
      <InfoBoxSpacer
        Height="0.1em"
        boxClassName="toolPalette-spacer-row ibox-spacer-hline"
      />
    );
    ibp.push(
      <GlobalDelete
        label="Clear Column"
        deleteType="single"
        gridType="ColumnsDataGrid"
        type="col"
        infoBox
        index={this.props.columnIndex}
        singleDeleteOperation={this.props.singleDeleteOperation}
      />
    );
    return ibp;
  };

  getHeaderLabel = (header, fromMenu = false) => {
    let title = '';
    if (header.isColumnLabelUpdated && !fromMenu) {
      title = header.label;
    } else if (header.autocodenode) {
      title = toLabelString(
        header.autocodenode,
        this.props.partsToShow,
        fromMenu
      );
    } else {
      title = `${header.tooltipVal ? header.tooltipVal : header.label}`;
    }
    if (title.includes('error')) {
      title = header.label;
    }
    return title;
  };

  render() {
    const {
      metricsList,
      metricsCount,
      sortOrder,
      columnHeight,
      sortKey,
      columnIndex,
      sortColumnIndex,
      rightmost,
    } = this.props;
    const { header } = this.state;

    const alignItems =
      columnHeight === `${MIN_ROW_HEIGHT}px` ? 'center' : 'baseline';

    return (
      <div
        className={
          header.isSelected ? 'c-table--col--selected' : 'c-table--col'
        }
      >
        <div className="title-container">
          {!this.state.editEnabled && (
            <div
              className={
                rightmost
                  ? 'c-table-infobox'
                  : 'c-table-infobox c-table-whiteright'
              }
              style={{ height: columnHeight }}
            >
              <div
                className="title-btn c-title-btn"
                title={`${this.getHeaderLabel(header)} ${
                  header.isColumnLabelUpdated ? String.fromCharCode(185) : ''
                }`}
                style={{ whiteSpace: 'normal', alignItems, display: 'flex' }}
              >
                <Label
                  editEnabled={
                    this.props.updatedTitleIndex === columnIndex &&
                    this.props.updatedTitleGridType === 'ColumnsDataGrid'
                  }
                  // label={header.isColumnLabelUpdated || !header.tooltipVal ? header.label : header.tooltipVal}
                  label={this.getHeaderLabel(header)}
                  toggleLabel={this.props.toggleCheckVal.column}
                  isLabelUpdated={header.isColumnLabelUpdated}
                  gridType="ColumnsDataGrid"
                  updateCrosstabGridTitleHeader={
                    this.props.updateCrosstabGridTitleHeader
                  }
                  updateGridData={this.props.updateGridData}
                  resetSelectedIndex={this.props.resetSelectedIndex}
                  index={columnIndex}
                  cols={50}
                  minRows={1}
                  maxRows={8}
                  style={{
                    left: '0px',
                    backgroundColor: '#424E61',
                    color: 'white',
                    'min-height': '35px',
                  }}
                  showFootNoteIcon={header.footnotes ? header.footnotes : []}
                  crosstabFootNotes={this.props.crosstabFootNotes}
                />
              </div>
              {columnIndex !== 0 && (
                <div className="c-table-infobox-ellipsis">
                  <InfoBox
                    Panels={this.buildInfoBox(
                      header,
                      this.props.toggleCheckVal.column,
                      columnIndex
                    )}
                    Positions={['bottom']}
                    InfoBoxButtonInner={
                      <img
                        className="ibox-ellipsis"
                        src={whiteEllipsisIcon}
                        alt="..."
                      />
                    }
                    Align="end"
                    containerClassName={
                      this.getHeaderLabel(header).length < 390
                        ? 'ibox-popover-container'
                        : !this.props.toggleCheckVal.column ||
                          header.isColumnLabelUpdated
                        ? 'ibox-popover-container-longText'
                        : 'ibox-popover-container'
                    }
                  />
                </div>
              )}
            </div>
          )}
        </div>
        {header.label !== '' && (
          <div className="cell">
            {metricsList &&
              metricsList.map((item, x) => (
                <div
                  key={x}
                  className="cell--item"
                  title={item.label}
                  style={this.getClassName(metricsCount)}
                >
                  <label
                    htmlFor={`${item.key}-header${columnIndex}`}
                    className={`cell--item-icon ${item.iconClass}`}
                  >
                    {sortKey === item.key &&
                      sortOrder === 'desc' &&
                      sortColumnIndex === columnIndex && <i>▼</i>}
                    {sortKey === item.key &&
                      sortOrder === 'asc' &&
                      sortColumnIndex === columnIndex && <i>▲</i>}
                  </label>
                  <button
                    type="button"
                    id={`${item.key}-header${columnIndex}`}
                    onClick={() => this.onPrivateEyeSort(item.key, columnIndex)}
                  >
                    {item.text}
                  </button>
                </div>
              ))}
          </div>
        )}
      </div>
    );
  }
}

ColumnHeader.propTypes = {
  metricsList: PropTypes.arrayOf(PropTypes.object),
  metricsCount: PropTypes.number,
  columnIndex: PropTypes.number,
  sortColumnIndex: PropTypes.number,
  sortOrder: PropTypes.string,
  sortKey: PropTypes.string,
  onSort: PropTypes.func,
  header: PropTypes.shape({}),
  toggleCheckVal: PropTypes.shape({
    column: PropTypes.bool,
  }),
  columnHeight: PropTypes.string,
  rightmost: PropTypes.bool,
  singleDeleteOperation: PropTypes.func,
  restoreGridTitle: PropTypes.func,
  updateCrosstabGridTitleHeader: PropTypes.func,
  updateGridData: PropTypes.func,
  resetSelectedIndex: PropTypes.func,
  updateGridTitle: PropTypes.func,
  partsToShow: PropTypes.shape({}),
  handleCrosstabEdit: PropTypes.func,
  crosstabFootNotes: PropTypes.shape({}),
};

export default React.memo(ColumnHeader);
